import { Maybe } from '@iss/libs/graphql';
import { inject, Pipe, PipeTransform } from '@angular/core';

import { ISS_HASH_FILES_MAP } from './hash-files.config';

@Pipe({
  name: 'woFileHash',
  standalone: true,
})
export class FileHashPipe implements PipeTransform {
  private readonly map = inject(ISS_HASH_FILES_MAP);

  public transform(filePath: Maybe<string>): string {
    return filePath ? this.getHashForStaticAsset(filePath) : '';
  }

  private addParamsToUrl(givenUrl: string, urlParameters: unknown): string {
    if (typeof urlParameters !== 'string' || urlParameters.length === 0) {
      return givenUrl;
    }

    const urlSplitByHash: string[] = givenUrl.split('#');
    const hash: string = urlSplitByHash[1] || '';
    const params: string[] = urlParameters.split('&');
    let url: string = urlSplitByHash[0];

    if (!url.includes('?')) {
      url += '?';
    } else {
      url += '&';
    }

    url += params.map((paramItem: string): string => {
      const p: string[] = paramItem.split('=');

      return `${p[0]}=${window.encodeURIComponent(p[1])}`;
    })
      .join('&');

    url = url.slice(0, -1); // remove last &

    return hash ? `${url}#${hash}` : url;
  }

  private getHashForStaticAsset(assetPath: string): string {
    const path: string = assetPath.split('#')[0];

    if (typeof this.map[path] === 'string') {
      return this.addParamsToUrl(assetPath, `c=${this.map[path]}`);
    }

    return '';
  }
}
